import dayjs from "dayjs";
import { viewDate } from "src/common/formats";
import { AttrTypeName } from "src/types/AttrType";
import { TreeLikeData } from "src/types/TreeLikeData";
import { ZAttribute } from "src/types/ZAttribute";
import { EntityFilterTreeData, ZEntityFilterValue } from "./types";

export const attr2TreeData = (
  { id, valueType }: ZAttribute,
  filterValue: ZEntityFilterValue,
  isLeaf: boolean,
  typesMap: Record<number, string>,
  key: string,
): TreeLikeData<EntityFilterTreeData> => ({
  key,
  title: transformTitleByType(filterValue.name, valueType, typesMap),
  attrId: id,
  filterValue,
  isLeaf,
});

const titleTransformers: Partial<
  Record<AttrTypeName, (title: string) => string>
> = {
  [AttrTypeName.date]: (title) =>
    dayjs(title).isValid() ? viewDate(title) : title,
};

const transformTitleByType = (
  title: string,
  valueType: number,
  typesMap: Record<number, string>,
): string =>
  titleTransformers[typesMap[valueType] as AttrTypeName]?.(title) ?? title;
